import { render, staticRenderFns } from "./m_indonesian_leadership_classC.vue?vue&type=template&id=3138dab4&scoped=true"
import script from "./m_indonesian_leadership_classC.vue?vue&type=script&lang=js"
export * from "./m_indonesian_leadership_classC.vue?vue&type=script&lang=js"
import style0 from "./m_indonesian_leadership_classC.vue?vue&type=style&index=0&id=3138dab4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3138dab4",
  null
  
)

export default component.exports